import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatDate, formatMoney, formatMoneyShorten, getCurrentTimestamp, roundToTwoDecimals } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdPrint, MdWarning } from "react-icons/md";
import logo from '../assets/logo.png';
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

export default function View({ studentUuid, examCycleUuid }) {

	const appContext = useContext(AppContext);
	

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [cycleUuid, setCycleUuid] = useState('');
	const [report, setReport] = useState(null);
	
	const invoiceRef = useRef(null);

	const printReport = useReactToPrint({
		contentRef: invoiceRef,
		documentTitle: "Report", // optional
	});

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllIndividualPaymentCycles(),
		]);
		setReady(true);
	}

	async function getReport() {
		if(cycleUuid) {
			setLoading(true);
			await callApi(
				'get-individual-payment-cycle-collection-report',
				{
					uuid: cycleUuid,
				}
			).then((response) => {
				if(response.status === 1) {
					setReport(response.data);
				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Please select classroom");
		}
	}

	
	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		setReport(null);
	}, [ cycleUuid ])

	useEffect(() => {
		//..
	}, [ report ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if (ready) {
		return (
			<div
				className="container"
			>
				<div className="row">

					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							Individual Payment Cycle Collection Report
						</h6>
						<hr/>
					</div>

					

					<div className="col-md-12 col-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								
								<div className="mt-3 mb-3">
									<label className="form-label">Select Individual Payment Cycle</label>
									<select
										value={cycleUuid}
										onChange={(e) => {
											setCycleUuid(e.target.value)
										}}
										className="form-control"
									>
										<option value='' ></option>
										{
											(appContext.allIndividualPaymentCycles && appContext.allIndividualPaymentCycles.length > 0) ?
											appContext.allIndividualPaymentCycles.map((item, i) => {
												return (
													<option key={item.id} value={item.uuid} >{item.title}</option>
												)
											})
											:""
										}
									</select>
								</div>

								<div className="mt-3 mb-3 text-end">

									<button
										className="btn btn-padded btn-sm btn-dark btn-rounded"
										onClick={() => {
											getReport();
										}}
									>
										Fetch Report
									</button>

								</div>

							</div>
						</div>
					</div>


					{
						(report) ?
						<div className="col-md-12 col-12 mt-2 mb-2">
							<div className="card">
								<div className="card-body">
									
									<h6
										className="card-title"
									>
										Individual Payment Cycle Collection Report
									</h6>

									<div className="text-end">
										<button
											className="btn btn-sm"
											onClick={() => {
												printReport()
											}}
										>
											<MdPrint size={24} />
											Print Now
										</button>
									</div>

									<hr/>

									<div
										className=""
										style={{
											width: "100%",
											overflow: "auto"
										}}
									>

										<div
											style={{
												minWidth: "600px",
												padding: "15px",
												
											}}
											className=""
											ref={invoiceRef}
										>
											
											<div 
												className="row"
											>
												
												<div className="col-6">
													<div className="d-flex">
														<img
															src={logo}
															style={{
																width: "150px",
																flexShrink: 0,
																height: "auto",
															}}
														/>
														<h6
															className="font-bold"
															style={{
																fontSize: "28px",
																wordWrap: "break-word",
															}}
														>
															<span
																style={{
																	textTransform: "uppercase",
																}}
															>
																{appContext.currentSchoolData.name}
															</span>
															

															<span
																className="font-bold d-block"
																style={{
																	fontSize: "12px"
																}}
															>
																Email: {appContext.currentSchoolData.contactEmail}
															</span>
															<span
																className="font-bold d-block"
																style={{
																	fontSize: "12px"
																}}
															>
																Phone: {appContext.currentSchoolData.contactPhone}
															</span>
															<span
																className="font-bold d-block"
																style={{
																	fontSize: "12px"
																}}
															>
																Website: {appContext.currentSchoolData.contactWebsite}
															</span>
															<span
																className="font-bold d-block"
																style={{
																	fontSize: "12px"
																}}
															>
																Address: {appContext.currentSchoolData.contactAddress}
															</span>
														</h6>
													</div>
								
													
												</div>
								
												<div className="col-6">
													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-bold   text-end"
													>
														INDIVIDUAL PAYMENT CYCLE COLLECTION REPORT
													</h6>
								
													<h6
														style={{
															fontSize: "24px"
														}}
														className="font-bold   text-end"
													>
														{report.individualPaymentCycleData.title}
													</h6>

													<h6
														style={{
															fontSize: "12px"
														}}
														className="font-semi-bold   text-end"
													>
														Payment Cycle Creation Date: {formatDate(report.individualPaymentCycleData.dateCreated)}
													</h6>
													<h6
														style={{
															fontSize: "12px"
														}}
														className="font-semi-bold   text-end"
													>
														Payment Cycle Due Date: {formatDate(report.individualPaymentCycleData.dateDue)}
													</h6>
													

													<h6
														style={{
															fontSize: "12px"
														}}
														className="font-semi-bold   text-end"
													>
														Report Generated On: {formatDate(getCurrentTimestamp())}
													</h6>
													
																	
								
												</div>

												<div className="col-12">
													<hr/>

													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														Number of Students: <span style={{ fontSize: "26px" }} className="font-bold">{report?.students?.length}</span>
													</h6>

													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														Total Expected Amount in TZS: <span style={{ fontSize: "26px"}} className="font-bold">{formatMoney(report.totalExpectedAmount)}</span>
													</h6>

													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														Total Amount Paid(Collected) in TZS: <span style={{ fontSize: "26px"}} className="font-bold">{formatMoney(report.totalAmountPaid)}</span>
													</h6>

													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														Total Discount Issued in TZS: <span style={{ fontSize: "26px"}} className="font-bold">{formatMoney(report.totalDiscountIssued)}</span>
													</h6>

													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														Total Unpaid(Uncollected) in TZS: <span style={{ fontSize: "26px"}} className="font-bold">{formatMoney(report.totalBalance)}</span>
													</h6>


													<hr/>

													{
														(report.students?.length > 0) ?
														<table className="table table-striped">
															<thead>
																<tr>
																	<th>
																		Student's fullname
																	</th>
																	<th>
																		Expected Amount (TZS)
																	</th>
																	<th>
																		Amount Paid (TZS)
																	</th>
																	<th>
																		Discount Issued (TZS)
																	</th>
																	<th>
																		Balance/Unpaid (TZS)
																	</th>
																	
																</tr>
															</thead>

															<tbody>
																{
																	report.students.map((item, i) => {
																		return (
																			<tr key={i}>
																				<td
																					style={{
																						textTransform: "uppercase",
																						fontFamily: "FontSemiBold",
																						cursor: 'pointer',
																					}}
																					onClick={() => {
																						appContext.navTo({
																							item: 'side-view',
																							subItem: 'student-options',
																							extraItem: item.uuid,
																						})
																					}}
																				>
																					{item.firstName} {item.middleName} {item.lastName}
																				</td>
																				<td>
																					{formatMoney(item.amountExpected)}
																				</td>
																				<td>
																					{formatMoney(item.amountPaid)}
																				</td>
																				<td>
																					{formatMoney(item.discountIssued)}
																				</td>
																				<td>
																					{formatMoney(item.balance)}
																				</td>
																				
																			</tr>
																		)
																	})
																}
															</tbody>
														</table>
														:
														<h6
															style={{
																fontSize: "14px"
															}}
														>
															No students were found
														</h6>
													}
												</div>
												
											</div>
							
										</div>

									</div>

								</div>
							</div>
						</div>
						:""
					}

					
					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}